/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { UploadDocumentInput } from './UploadDocumentInput';
import {
    UploadDocumentInputFromJSON,
    UploadDocumentInputFromJSONTyped,
    UploadDocumentInputToJSON,
    UploadDocumentInputToJSONTyped,
} from './UploadDocumentInput';
import type { DocumentReceivedVia } from './DocumentReceivedVia';
import {
    DocumentReceivedViaFromJSON,
    DocumentReceivedViaFromJSONTyped,
    DocumentReceivedViaToJSON,
    DocumentReceivedViaToJSONTyped,
} from './DocumentReceivedVia';

/**
 * 
 * @export
 * @interface StaffUploadBatchRequest
 */
export interface StaffUploadBatchRequest {
    /**
     * 
     */
    batch_id: string;
    /**
     * 
     */
    received_via: DocumentReceivedVia;
    /**
     * 
     */
    received_at?: Date | null;
    /**
     * 
     */
    attributed_participant_id?: string | null;
    /**
     * 
     */
    request_item_id?: string | null;
    /**
     * 
     */
    documents: Array<UploadDocumentInput>;
}



/**
 * Check if a given object implements the StaffUploadBatchRequest interface.
 */
export function instanceOfStaffUploadBatchRequest(value: object): value is StaffUploadBatchRequest {
    if (!('batch_id' in value) || value['batch_id'] === undefined) return false;
    if (!('received_via' in value) || value['received_via'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function StaffUploadBatchRequestFromJSON(json: any): StaffUploadBatchRequest {
    return StaffUploadBatchRequestFromJSONTyped(json, false);
}

export function StaffUploadBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffUploadBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'batch_id': json['batch_id'],
        'received_via': DocumentReceivedViaFromJSON(json['received_via']),
        'received_at': json['received_at'] === undefined ? undefined : json['received_at'] === null ? null : (parseDateTime(json['received_at'])),
        'attributed_participant_id': json['attributed_participant_id'] === undefined ? undefined : json['attributed_participant_id'] === null ? null : json['attributed_participant_id'],
        'request_item_id': json['request_item_id'] === undefined ? undefined : json['request_item_id'] === null ? null : json['request_item_id'],
        'documents': ((json['documents'] as Array<any>).map(UploadDocumentInputFromJSON)),
    };
}

export function StaffUploadBatchRequestToJSON(json: any): StaffUploadBatchRequest {
    return StaffUploadBatchRequestToJSONTyped(json, false);
}

export function StaffUploadBatchRequestToJSONTyped(value?: StaffUploadBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batch_id'],
        'received_via': DocumentReceivedViaToJSON(value['received_via']),
        'received_at': value['received_at'] == null ? value['received_at'] : serializeDateTime(value['received_at']),
        'attributed_participant_id': value['attributed_participant_id'],
        'request_item_id': value['request_item_id'],
        'documents': ((value['documents'] as Array<any>).map(UploadDocumentInputToJSON)),
    };
}

